import useArticle from './useArticle';
import useArticleFragment from './useArticleFragment';
/**
 * Return wether the article (either passed in or from context) is active.
 * An article is active when it is the article in the url param for the current page.
 * @param articleId if provided will use this instead of the currently set article in the context
 */
export default function useIsArticleActive(articleId) {
    const article = useArticle();
    const fragment = useArticleFragment();
    if (!article)
        return false;
    if (articleId)
        return articleId === article.id;
    if (fragment)
        return fragment.id === article.id;
    return false;
}
//# sourceMappingURL=useIsArticleActive.js.map